<div class="ws-screen" [class.zu-100fvh]="dataService.hideScreen$ | async">
  <div class="ws-screen-header">
    <app-menu></app-menu>
  </div>

  <div class="ws-screen-title">
    <div class="ws-screen-header__filler">&nbsp;</div>
    <app-screen-title></app-screen-title>
  </div>

  <router-outlet></router-outlet>
</div>

<div class="footer">
  <app-footer-version></app-footer-version>
  <app-footer-copyright></app-footer-copyright>
</div>
